import { LEAVES_REQUEST } from '../actions/utilities';

const INITIAL_STATE = {
    getLeaveTypeLoading: false,
    getLeaveTypeSuccess: false,
    getLeaveTypeFailure: false,
    getLeaveTypeError: null,
    leaveTypes: [],
    leavesRequestLoading: false,
    leavesRequestSuccess: false,
    leavesRequestFailure: false,
    leavesRequestError: null,
    leavesRequest: [],
    updateLeaveRequestLoading: false,
    updateLeaveRequestSuccess: false,
    updateLeaveRequestFailure: false,
    updateLeaveRequestError: null,
}

export const leavesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LEAVES_REQUEST.GET_LEAVE_TYPE_REQUEST:
            return {
                ...state,
                getLeaveTypeLoading: true,
                getLeaveTypeSuccess: false,
                getLeaveTypeFailure: false,
                getLeaveTypeError: null
            }
        case LEAVES_REQUEST.GET_LEAVE_TYPE_SUCCESS:
            return {
                ...state,
                getLeaveTypeLoading: false,
                getLeaveTypeSuccess: true,
                getLeaveTypeFailure: false,
                getLeaveTypeError: null,
                leaveTypes: action.payload
            }
        case LEAVES_REQUEST.GET_LEAVE_TYPE_FAILURE:
            return {
                ...state,
                getLeaveTypeLoading: false,
                getLeaveTypeSuccess: false,
                getLeaveTypeFailure: true,
                getLeaveTypeError: action.payload
            }
        case LEAVES_REQUEST.GET_LEAVES_REQUEST:
            return {
                ...state,
                leavesRequestLoading: true,
                leavesRequestSuccess: false,
                leavesRequestFailure: false,
                leavesRequestError: null
            }
        case LEAVES_REQUEST.GET_LEAVES_SUCCESS:
            return {
                ...state,
                leavesRequestLoading: false,
                leavesRequestSuccess: true,
                leavesRequestFailure: false,
                leavesRequestError: null,
                leavesRequest: action.payload
            }
        case LEAVES_REQUEST.GET_LEAVES_FAILURE:
            return {
                ...state,
                leavesRequestLoading: false,
                leavesRequestSuccess: false,
                leavesRequestFailure: true,
                leavesRequestError: action.payload
            }
        case LEAVES_REQUEST.UPDATE_LEAVES_STATUS_REQUEST:
            return {
                ...state,
                updateLeaveRequestLoading: true,
                updateLeaveRequestSuccess: false,
                updateLeaveRequestFailure: false,
                updateLeaveRequestError: null,
            }
        case LEAVES_REQUEST.UPDATE_LEAVES_STATUS_SUCCESS:
            let leave_data = state.leavesRequest;
            // console.log("payload::", action.payload);
            for (var i = 0; i < leave_data.length; i++) {
                if (leave_data[i].attendanceId === action.payload.attendanceId) {
                    leave_data[i].status = action.payload.status
                }
            }
            return {
                ...state,
                updateLeaveRequestLoading: false,
                updateLeaveRequestSuccess: true,
                updateLeaveRequestFailure: false,
                updateLeaveRequestError: null,
            }
        case LEAVES_REQUEST.UPDATE_LEAVES_STATUS_FAILURE:
            return {
                ...state,
                updateLeaveRequestLoading: false,
                updateLeaveRequestSuccess: false,
                updateLeaveRequestFailure: true,
                updateLeaveRequestError: action.payload,
            }
        case LEAVES_REQUEST.LEAVES_REQUEST_RESET:
            return {
                ...state,
                updateLeaveRequestLoading: false,
                updateLeaveRequestSuccess: false,
                updateLeaveRequestFailure: false,
                updateLeaveRequestError: null,
            }
        default:
            return state;
    }
}